import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAudioPlayer } from "@/context/AudioContext";
import AppBottomNav from "./components/AppBottomNav";
import AppFeedTab from "./components/AppFeedTab";
import AppExploreTab from "./components/AppExploreTab";
import AppLiveTab from "./components/AppLiveTab";
import AppCommunityTab from "./components/AppCommunityTab";
import type { AppTabId } from "./components/AppBottomNav";

/* Reutilizamos las tabs existentes con el contexto de red social */
import AppProfileTab from "./components/AppProfileTab";

export default function AppPage() {
  const [activeTab, setActiveTab] = useState<AppTabId>("feed");
  const navigate = useNavigate();
  const { currentStation } = useAudioPlayer();

  const showGlobalPlayer = !!currentStation;

  return (
    <div className="fixed inset-0 flex flex-col bg-background-50 overflow-hidden">
      {/* Content area — padded at bottom when GlobalPlayer shows */}
      <div
        className={`flex-1 overflow-hidden relative safe-top ${
          showGlobalPlayer ? "pb-14 md:pb-16" : ""
        }`}
      >
        {/* Feed Tab — Inicio */}
        <div
          className={`absolute inset-0 transition-opacity duration-200 ${
            activeTab === "feed" ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
          }`}
        >
          <AppFeedTab onNavigateFollowing={() => navigate("/app/siguiendo")} />
        </div>

        {/* Explore Tab — Explorar */}
        <div
          className={`absolute inset-0 transition-opacity duration-200 overflow-hidden ${
            activeTab === "explore" ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
          }`}
        >
          <AppExploreTab />
        </div>

        {/* Live Tab — En Vivo (Player) */}
        <div
          className={`absolute inset-0 transition-opacity duration-200 overflow-hidden ${
            activeTab === "live" ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
          }`}
        >
          <AppLiveTab isActive={activeTab === "live"} onPlayStation={() => {}} />
        </div>

        {/* Community Tab — Comunidad */}
        <div
          className={`absolute inset-0 transition-opacity duration-200 overflow-hidden ${
            activeTab === "community" ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
          }`}
        >
          <AppCommunityTab />
        </div>

        {/* Profile Tab — Perfil */}
        <div
          className={`absolute inset-0 transition-opacity duration-200 overflow-hidden ${
            activeTab === "profile" ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
          }`}
        >
          <AppProfileTab isActive={activeTab === "profile"} />
        </div>
      </div>

      {/* Bottom Navigation — 5 tabs: Inicio · Explorar · En Vivo · Comunidad · Perfil */}
      <AppBottomNav activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
}